// removed by extract-text-webpack-plugin
module.exports = {"result":"antd-pro-result-result","icon":"antd-pro-result-icon","success":"antd-pro-result-success","error":"antd-pro-result-error","title":"antd-pro-result-title","description":"antd-pro-result-description","extra":"antd-pro-result-extra","actions":"antd-pro-result-actions"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Result/index.less
// module id = 1035
// module chunks = 0